import styled from "styled-components";

export const IconWrapper = styled.div`
  display: inline-flex;
  margin-left: 5px;
  cursor: pointer;
`;
